
        Component.define('modal-filter-vehicle', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $btnClose       = $('.btn-close');
const $btnFilter      = $('.brand .radio-default')

$btnClose.on('click', function(){
    $('.wrapper-filter').removeClass('open');
    $body.removeClass('modal-opened');
});

// if($(this).attr('checked')) {
//     $('.products').hide();
// }

$btnFilter.on('click', function(){
    const filterValue = $(this).val();

    $el.find('.wrapper-vehicles input').not(this).prop('checked', false);
    $el.find('.product').hide();
    $el.find('.products').hide();
    $el.find('.products.'+filterValue).show();
    $el.find('.products.'+filterValue).closest('.product').fadeIn();

});

$el.find('.radio-button-default').on('click', function(){
    //$('.wrapper-vehicles').addClass('hide');
    //$('.wrapper-period').removeClass('hide');

    $el.find('.btn-filtrar').fadeIn();
});

$el.on('filter:open', function(evt, data){
    //console.log(data);
    $el.find('.product').hide();
    $el.find('[data-filter]').hide();
    $el.find('[data-filter]').closest('.wrapper-filter').removeClass('open');
    $el.find('[data-filter="'+data+'"]').closest('.wrapper-filter').addClass('open');
    $el.find('[data-filter="'+data+'"]').fadeIn();
    $el.find('.products input').prop('checked', false);
    $el.find('.wrapper-vehicles input').prop('checked', false);
    $body.addClass('modal-opened');
});

$el.find('form').on('submit', function(){
    let products = [];
    $el.find('[name="product"]:checked').each(function(){
        let val = $(this).val();
        $(this).prop('disabled', true);
        products.push(val);
    });

    $(this).append(`<input type="hidden" name="products" value="${products.join('-')}">`);
});

        });